import { cloudAction } from './cloud/account.js';
import { planAction } from './cloud/plan.js';
import { CLOUD } from './cloud/api.js';
import { setStatus } from './cloud/sync.js';
import { today } from './dates.js';
import { buildICS, exportInvoicesCSV, exportSessionsCSV, parseICS } from './exporters.js';
import { t } from './i18n/index.js';
import { download, waLink } from './messaging.js';
import { getEvent, stu } from './model.js';
import { S, persist, uid } from './state.js';
import { $, CAL, IC, RT, closeSheet, esc, nav, render, sheet, sheetStack, toast } from './ui.js';
import { openHelp } from './help.js';
import { openUpgrade } from './cloud/plan.js';
import { openFeedSheet } from './notify/feed.js';
import { calNav, dayAgenda, openEventSheet, openLessonEditor } from './views/calendar.js';
import { bindInvoiceList, openInvoice, openInvoiceBuilder, openMonthRun } from './views/invoices.js';
import { openMessenger } from './views/messenger.js';
import { openRecap } from './views/recap.js';
import { bindSettings, openSettings } from './views/settings.js';
import { bindContact } from './views/contact.js';
import { bindTeam } from './views/team.js';
import { bindTinv } from './views/tinv.js';
import { TF } from './team/team.js';
import { openPackageSheet, openStudentEditor, removePackage, setShowArch, setStuQ } from './views/students.js';
import { bindParentCard } from './cloud/parents.js';
import { bindParents } from './views/parents.js';
import { startTimer } from './views/timer.js';
import { startHomeTicker } from './views/home.js';
import { openWorkspaceMenu } from './menu.js';
import { bindReminders } from './notify/reminders.js';
import { bindGroups } from './views/groups.js';

export function bindEvtRows(root){
  root.querySelectorAll('[data-evt]').forEach(el=>el.addEventListener('click',e=>{
    if(e.target.closest('[data-meet],[data-start],[data-recap]'))return;
    const evt=getEvent(el.dataset.evt);if(evt)openEventSheet(evt);
  }));
  root.querySelectorAll('[data-evt][role=button]').forEach(el=>el.addEventListener('keydown',e=>{
    if(e.target!==el||(e.key!=='Enter'&&e.key!==' '))return;e.preventDefault();el.click();
  }));
  root.querySelectorAll('[data-meet]').forEach(el=>el.onclick=e=>{e.stopPropagation();window.open(el.dataset.meet,'_blank')});
  root.querySelectorAll('[data-start]').forEach(el=>el.onclick=e=>{e.stopPropagation();const evt=getEvent(el.dataset.start);if(evt)startTimer(evt)});
  root.querySelectorAll('[data-recap]').forEach(el=>el.onclick=e=>{e.stopPropagation();openRecap(el.dataset.recap)});
}
export function bindView(m){
  m.querySelectorAll('[data-story]').forEach(el=>el.onclick=()=>import('./story.js').then(x=>x.openStory()));
  m.querySelectorAll('[data-dismiss]').forEach(el=>el.onclick=()=>{S.settings.dismissed=S.settings.dismissed||{};S.settings.dismissed[el.dataset.dismiss]=true;persist();render()});
  bindEvtRows(m);
  m.querySelectorAll('[data-go]').forEach(el=>el.onclick=()=>nav(el.dataset.go));
  m.querySelectorAll('[data-set]').forEach(el=>el.onclick=()=>openSettings(el.dataset.set));
  m.querySelectorAll('[data-trialup]').forEach(el=>el.onclick=()=>openUpgrade());
  m.querySelectorAll('[data-stu]').forEach(el=>el.addEventListener('click',e=>{if(e.target.closest('[data-wa],[data-em],[data-sched],[data-msg]'))return;nav('student',el.dataset.stu)}));
  m.querySelectorAll('[data-msg]').forEach(el=>el.onclick=e=>{e.stopPropagation();openMessenger(el.dataset.msg)});
  m.querySelectorAll('[data-wa]').forEach(el=>el.onclick=e=>{e.stopPropagation();const s=stu(el.dataset.wa);window.open(waLink(s.phone,''),'_blank')});
  m.querySelectorAll('[data-em]').forEach(el=>el.onclick=e=>{e.stopPropagation();const s=stu(el.dataset.em);location.href='mailto:'+s.email});
  m.querySelectorAll('[data-sched]').forEach(el=>el.onclick=e=>{e.stopPropagation();const s=stu(el.dataset.sched);openLessonEditorFor(s.id)});
  m.querySelectorAll('[data-hwdone]').forEach(el=>el.onclick=()=>{const s=S.sessions.find(x=>x.id===el.dataset.hwdone);if(s&&s.summary){s.summary.hwDone=true;persist();render()}});
  m.querySelectorAll('[data-inv]').forEach(el=>el.onclick=()=>openInvoice(el.dataset.inv));
  bindInvoiceList(m);
  bindGroups(m,openLessonEditor);
  bindParentCard(m,id=>openStudentEditor(id));
  bindParents(m,id=>openStudentEditor(id));
  m.querySelectorAll('[data-fu]').forEach(el=>el.onclick=()=>{const[act,id]=el.dataset.fu.split(':');
    if(act==='evt'){const ev=getEvent(id);if(ev)openEventSheet(ev)}else if(act==='recap')openRecap(id);else if(act==='invoice')openInvoiceBuilder(id);else if(act==='inv')openInvoice(id);else if(act==='plan')openLessonEditorFor(id)});
  m.querySelectorAll('[data-a]').forEach(el=>{
    const a=el.dataset.a;
    if(a==='newlesson')el.onclick=()=>openLessonEditor(null,CAL.mode&&RT.v==='calendar'?CAL.anchor:today());
    if(a==='newstudent')el.onclick=()=>openStudentEditor();
    if(a==='newinvoice')el.onclick=()=>openInvoiceBuilder();
    if(a==='monthrun')el.onclick=()=>openMonthRun();
    if(a==='pkgnew')el.onclick=()=>openPackageSheet(RT.id);
    if(a==='pkgdel')el.onclick=()=>removePackage(RT.id,el.dataset.pkg);
    if(a==='pkginv')el.onclick=()=>openInvoice(el.dataset.inv);
    if(a==='planfor')el.onclick=()=>openLessonEditorFor(el.dataset.stu);
    if(a==='stuedit')el.onclick=()=>openStudentEditor(RT.id);
    if(a==='stuinv')el.onclick=()=>openInvoiceBuilder(RT.id);
    if(a==='ics')el.onclick=()=>download('plume-calendar.ics',buildICS(),'text/calendar');
    if(a==='calmore')el.onclick=()=>{
      const b=sheet(`<div class="sheethead"><h2>${t('cal.moreTitle')}</h2><button class="iconbtn" data-x aria-label="${esc(t('c.close'))}">${IC.x}</button></div>
      <div class="sheetbody menu">
        <button class="menuitem" data-m="feed">${IC.cal}<span><b>${t('feed.title')}</b><small>${t('cal.moreFeed')}</small></span></button>
        <button class="menuitem" data-m="exp">${IC.dl}<span><b>${t('cal.ics')}</b><small>${t('cal.moreExp')}</small></span></button>
        <button class="menuitem" data-m="imp">${IC.plus}<span><b>${t('cal.icsImport')}</b><small>${t('cal.moreImp')}</small></span></button>
      </div>`);
      b.querySelector('[data-x]').onclick=()=>closeSheet(b);
      b.querySelector('[data-m=feed]').onclick=()=>{closeSheet(b);openFeedSheet()};
      b.querySelector('[data-m=exp]').onclick=()=>{closeSheet(b);download('plume-calendar.ics',buildICS(),'text/calendar')};
      b.querySelector('[data-m=imp]').onclick=()=>{closeSheet(b);const f=document.getElementById('icsfile');if(f)f.click()};
    };
    if(a==='csvS')el.onclick=exportSessionsCSV;
    if(a==='csvI')el.onclick=exportInvoicesCSV;
  });
  m.querySelectorAll('[data-cm]').forEach(el=>el.onclick=()=>{CAL.mode=el.dataset.cm;render()});
  m.querySelectorAll('[data-cal]').forEach(el=>el.onclick=()=>calNav(+el.dataset.cal));
  m.querySelectorAll('[data-day]').forEach(el=>el.addEventListener('click',e=>{
    if(e.target.closest('[data-evt]'))return;
    if(CAL.mode==='week')openLessonEditor(null,el.dataset.day);else dayAgenda(el.dataset.day);
  }));
  const icsf=m.querySelector('#icsfile');
  if(icsf)icsf.onchange=e=>{
    const f=e.target.files[0];if(!f)return;
    const r=new FileReader();
    r.onload=()=>{
      const evs=parseICS(r.result);
      if(!evs.length){toast(t('cal.icsNone'));return}
      const first=S.students.filter(s=>!s.archived)[0];
      let n=0;
      for(const ev of evs){
        const match=S.students.find(s=>ev.summary.toLowerCase().includes(s.first.toLowerCase()));
        S.sessions.push({id:uid(),studentId:(match||first).id,date:ev.date,time:ev.time,dur:ev.dur,status:ev.date<today()?'done':'planned',meet:/meet\.google/.test(ev.loc)?ev.loc:'',notes:ev.summary});n++;
      }
      persist();render();toast(t('cal.icsDone',{n}));
    };
    r.readAsText(f);
  };
  const sq=m.querySelector('#stuq');
  if(sq){sq.oninput=()=>{setStuQ(sq.value);const scroll=window.scrollY;render();const nq=$('#stuq');nq.focus();nq.setSelectionRange(nq.value.length,nq.value.length);window.scrollTo(0,scroll)}}
  const ac=m.querySelector('#archck');
  if(ac)ac.onchange=()=>{setShowArch(ac.checked);render()};
  if(RT.v==='settings')bindSettings(m);
  if(RT.v==='contact')bindContact(m);
  bindTeam(m);
  bindTinv(m);
  m.querySelectorAll('[data-tf]').forEach(el=>el.onclick=()=>{TF.id=el.dataset.tf;render()});
  bindReminders(m);
  if(RT.v==='home')startHomeTicker(m);
  m.querySelectorAll('[data-ca]').forEach(el=>el.onclick=()=>cloudAction(el.dataset.ca));
  m.querySelectorAll('[data-pl]').forEach(el=>el.onclick=()=>planAction(el.dataset.pl));
  setStatus(CLOUD.status);
}
export function openLessonEditorFor(stuId){
  openLessonEditor(null,today());
  setTimeout(()=>{const sel=document.querySelector('#le-stu');if(sel)sel.value=stuId},20);
}
/* nav buttons + fab */
export function bindHelp(){document.querySelectorAll('[data-help]').forEach(b=>{if(!b._h){b._h=1;b.addEventListener('click',openHelp)}})}
export function initBindings(){
document.querySelectorAll('[data-nav]').forEach(b=>b.onclick=()=>nav(b.dataset.nav));
document.querySelectorAll('[data-wsbtn]').forEach(b=>b.onclick=e=>{e.stopPropagation();openWorkspaceMenu(b)});
$('#fab').onclick=()=>{
  const b=sheet(`<div class="sheetbody" style="padding-top:20px">
    <button class="btn big mb8" style="width:100%;justify-content:flex-start" data-f="lesson">${IC.cal} ${t('home.addLesson')}</button>
    <button class="btn big mb8" style="width:100%;justify-content:flex-start" data-f="student">${IC.plus} ${t('home.addStudent')}</button>
    <button class="btn big" style="width:100%;justify-content:flex-start" data-f="invoice">${IC.doc} ${t('home.newInvoice')}</button>
  </div>`);
  b.querySelector('[data-f=lesson]').onclick=()=>{closeSheet(b);openLessonEditor(null,today())};
  b.querySelector('[data-f=student]').onclick=()=>{closeSheet(b);openStudentEditor()};
  b.querySelector('[data-f=invoice]').onclick=()=>{closeSheet(b);openInvoiceBuilder()};
};
window.addEventListener('afterprint',()=>{$('#printroot').innerHTML=''});
document.addEventListener('keydown',e=>{if(e.key==='Escape'&&sheetStack.length)closeSheet()});

/* ================= cloud: Supabase auth + sync (REST, no SDK) ================= */
}
